import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: 'app-daily-operation',
  templateUrl: './daily-operation.component.html',
  styleUrls: ['./daily-operation.component.scss']
})
export class DailyOperationComponent implements OnInit {

  displayHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private router: Router
  ) { }

  ngOnInit() {

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event :NavigationEnd )=> {
      //remove basket url + remove brackets + remove empty path + pop = last primary root !
      let url = event.urlAfterRedirects.replace('basket:basket','').replace(/[)(]*/g,'').split('/').filter(ele => ele.length != 0).pop();
      this.displayHeader.next(url === "porteurs" || url === "lp" ||  'edit-stock' == url);
    });

  }

}
